module.exports = __webpack_public_path__ + "img/archived-card-icon.163ef11d.svg";